import { Component, OnInit } from '@angular/core';
import { MemberQuery, TierService, TierQuery } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-tier-level-page',
  templateUrl: './tier-level-page.component.html',
  styleUrl: './tier-level-page.component.scss',
})
export class TierLevelPageComponent implements OnInit {
  tierName: string | undefined;
  tierAchieved: any[] = [];
  tierLevels: any[] = [];

  constructor(
    private memberQuery: MemberQuery,
    private tierQuery: TierQuery,
    private tierService: TierService
  ) {}

  ngOnInit() {
    this.tierName = this.memberQuery.getUserContext().tierName;

    firstValueFrom(this.tierService.fetchTiers(this.memberQuery.getUserContext().clubId));
    //get list all tiers
    this.tierQuery.tiers$.subscribe((data) => {
      this.tierLevels = data;

      //get list tiers achieved
      if (this.tierLevels?.length > 0) {
        const tierIndex = this.tierLevels.findIndex(
          (tier) => tier.Name.toLowerCase().trim() === this.tierName?.toLowerCase().trim()
        );
        if (tierIndex !== -1) {
          this.tierAchieved = this.tierLevels.slice(0, tierIndex + 1);
        }
      }
    });
  }
}
